module.exports = __webpack_public_path__ + "img/低通锐化25.eb11ee63.png";